import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { AuthService } from '../services/auth.service';
import { AsyncPipe } from '@angular/common';
import { Video } from '../models/video-interface';

import { VideoListComponent } from '../videolist/videolist.component';
import { VideoViewerComponent } from '../videoviewer/videoviewer.component';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.css'],
    imports: [VideoListComponent, VideoViewerComponent, AsyncPipe]
})
export class VideoComponent implements OnInit {

  title = 'Video Portal';
  selectedVideo: Video | null = null;
 
  videos: Video[] = [];

  isLoading = false;
  isInitiatingCheckout = false;
  isBrowser = false;
  
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';

  constructor(private http: HttpClient, public auth: AuthService, private snackBar: MatSnackBar, @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) { 
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    this.isLoading = true;
    if (this.isBrowser) {
      this.http.post<Video[]>('api/products/getVideos.php', {}).subscribe({
          next: (data) => {
            this.videos = data;

            this.videos.sort((a, b) => a.item_CODE.localeCompare(b.item_CODE));

            this.isLoading = false;

            if(this.auth.isLoggedIn()) {
                this.getVideoPermsions();
            }
            this.cdr.markForCheck();
          },
          error: (error) => {
            console.error('Error fetching products:', error);
            this.isLoading = false;
            this.cdr.markForCheck();
          }
        });      

    this.logPage('video');
    } else {
      this.isLoading = false;
    }
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }


  getVideoPermsions(){

      //get back list of videos that member has bought from member_videos table
      //loop videos[] and mark hasPermission = true
        this.snackBar.open('Fetching video permissions...', 'Dismiss', { duration: 2000 });
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        // Using POST as requested, with an empty body for this simple fetch
        this.http.post<{ item_CODE: string }[]>('api/members/getVideoPermissions.php', {memberID: this.auth.currentUser.memberID}, { headers }).subscribe({
          next: (permissionData) => {
            if (Array.isArray(permissionData)) {
              // Create a Set for efficient lookup of permission IDs
              const permittedIds = new Set<string>(permissionData.map(item => item.item_CODE));

              this.videos = this.videos.map(video => {
                const updatedVideo = {
                  ...video,
                  hasPermission: permittedIds.has(video.item_CODE) // Check if video.id is in the set of permitted IDs
                };
                // Append memberid to the URL
                updatedVideo.videoUrl = `${updatedVideo.videoUrl}&memberID=${this.auth.currentUser.memberID}`;
                return updatedVideo;
              });

              // bring users purchased videos to top of list
              this.videos.sort((a, b) => {
                    // If 'a' has permission and 'b' does not, 'a' comes first (return -1)
                    if (a.hasPermission && !b.hasPermission) {
                      return -1;
                    }
                    
                    // If 'b' has permission and 'a' does not, 'b' comes first (return 1)
                    if (!a.hasPermission && b.hasPermission) {
                      return 1;
                    }

                    // If both are true or both are false, their order remains unchanged (return 0)
                    return 0;
                  });


              this.snackBar.open('Video permissions updated!', 'Close', { duration: 3000, panelClass: ['snackbar-success'] });
              this.cdr.markForCheck();
            } else {
              this.snackBar.open('Unexpected data format for permissions.', 'Close', { duration: 5000, panelClass: ['snackbar-error'] });
              this.cdr.markForCheck();
            }
          },
          error: (error) => {
            this.snackBar.open('Error fetching video permissions.', 'Close', { duration: 5000, panelClass: ['snackbar-error'] });
            console.error('Error fetching video permissions:', error);
            this.cdr.markForCheck();
          }
        });
  }

  
  isLoggedIn(){

    return this.auth.isLoggedIn();
  }


  onVideoSelected(video: Video): void {
    // In a real application, you would make an API call here to check for
    // server-side permissions before setting the selected video.
    // For this example, we use the `hasPermission` property from mock data.
    if (this.auth.isLoggedIn() && video.hasPermission) {
      this.selectedVideo = video      
    } else {
      //console.warn(`User is not logged in or does not have permission to view: ${video.title}`); 
      this.openSnackBar(`User does not have permission to view: ${video.title}`, 'Dismiss')
    }
  }

  openSnackBar(msg: string, action: string) {
    this.snackBar.open(msg, action, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000
    });
  }

  backToList(): void {
    this.selectedVideo = null;
  }
}
